module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "slider-prev-black.0ff0ae4b.svg";